unit ULoginForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UMainConfig,
  WEBLib.Buttons;

type
  TLoginForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnMenu: TImageControl;
    pnlFooter: TPanel;
    pnlMain: TPanel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    edtUsername: TEdit;
    edtPasswort: TEdit;
    WebLabel3: TLabel;
    btnLogin: TBitBtn;
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnLoginClick(Sender: TObject);
    procedure imgLogoClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    procedure edtUsernameKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
  private
    { Private-Deklarationen }
    FMainConfig: TMainConfig;
    procedure Error(Sender: TObject; AMsg: string);
    procedure PwResult(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetMask;
    [Async]
    procedure LoggedIn(Sender: TObject); async;
  public
    { Public-Deklarationen }
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
  protected procedure LoadDFMValues; override; end;

var
  LoginForm: TLoginForm;

implementation

uses
  UEssentialHelper, UUserModel, UMenuForm, UMenu1Form;

{$R *.dfm}
{ TLoginForm }

procedure TLoginForm.btnLoginClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  TUserModel.IsPwCorrect(Self.MainConfig.Uri, edtUsername.Text,
    edtPasswort.Text, @PwResult, @Error);
end;

procedure TLoginForm.edtUsernameKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  Self.MainConfig.TimerReset;
end;

procedure TLoginForm.Error(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOk], nil);
end;

procedure TLoginForm.imgLogoClick(Sender: TObject);
begin
  window.location.href := 'https://www.delco.de';
end;

procedure TLoginForm.LoggedIn(Sender: TObject);
var
  frm: TMenuForm;
  frm1: TMenu1Form;
begin
  if Self.MainConfig.User.PersonalNr <> '' then
  begin
    case Self.MainConfig.CommonConfig.PrimaryPage of
      0:
        begin
          frm := TMenuForm.Create(Self);
          frm.Caption := Self.Caption;
          frm.Popup := false;
          await(TMenuForm, frm.Load);
          frm.MainConfig := Self.MainConfig;
          try
            Self.Hide;
            await(TModalResult, frm.Execute);
          finally
            frm.Free;
            Self.Show;
            Self.WebFormResize(Sender);
          end;
        end;
      1:
        begin
          frm1 := TMenu1Form.Create(Self);
          frm1.Caption := Self.Caption;
          frm1.Popup := false;
          await(TMenu1Form, frm1.Load);
          frm1.MainConfig := Self.MainConfig;
          try
            Self.Hide;
            await(TModalResult, frm1.Execute);
          finally
            frm1.Free;
            Self.Show;
            Self.WebFormResize(Sender);
          end;
        end;
    end;
  end
  else
    MessageDLG('Benutzer nicht gefunden!', mtWarning, [mbOk]);
end;

procedure TLoginForm.PwResult(Sender: TObject);
begin
  if Sender is TBooleanValue then
  begin
    if (Sender as TBooleanValue).Value then
    begin
      Self.MainConfig.User.OnPropertyChanged := LoggedIn;
      Self.MainConfig.User.OnError := Self.Error;
      Self.MainConfig.User.GetByRemote_User(Self.MainConfig.Uri,
        edtUsername.Text);
    end
    else
      MessageDLG('Benutzername oder Passwort falsch!', mtWarning, [mbOk]);
  end;
  Self.SetMask;
end;

procedure TLoginForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  Self.MainConfig.TimerReset;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
  Self.SetMask;
end;

procedure TLoginForm.SetMask;
begin
  edtUsername.Text := '';
  edtPasswort.Text := '';
end;

procedure TLoginForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TLoginForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnMenu.Width := 24;
    btnMenu.Height := 24;
    btnMenu.Top := 4;
    btnMenu.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
  end
  else
  begin
    btnMenu.Width := 48;
    btnMenu.Height := 48;
    btnMenu.Top := 8;
    btnMenu.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnMenu.Left + btnMenu.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - btnMenu.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  i := Self.ClientHeight - pnlHeader.Height - pnlMain.Height;
  if pnlFooter.Visible then
    i := i - pnlFooter.Height;
  i := i div 2;
  if i < 0 then
    i := 0;
  pnlMain.Top := pnlHeader.Height + i;
  i := (Self.ClientWidth - pnlMain.Width) div 2;
  if i < 0 then
    i := 0;
  pnlMain.Left := i;
end;

procedure TLoginForm.WebFormShow(Sender: TObject);
begin
  WebFormResize(Sender);
end;

procedure TLoginForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnMenu := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlMain := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  edtUsername := TEdit.Create(Self);
  edtPasswort := TEdit.Create(Self);
  btnLogin := TBitBtn.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnMenu.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlMain.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  edtUsername.BeforeLoadDFMValues;
  edtPasswort.BeforeLoadDFMValues;
  btnLogin.BeforeLoadDFMValues;
  try
    Name := 'LoginForm';
    Width := 640;
    Height := 480;
    Caption := 'Winzeit - WebPortal';
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    SetEvent(imgLogo, Self, 'OnClick', 'imgLogoClick');
    imgLogo.Picture.LoadFromFile('ULoginForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnMenu.SetParentComponent(pnlHeader);
    btnMenu.Name := 'btnMenu';
    btnMenu.Left := 8;
    btnMenu.Top := 8;
    btnMenu.Width := 48;
    btnMenu.Height := 48;
    btnMenu.HeightPercent := 100.000000000000000000;
    btnMenu.WidthPercent := 100.000000000000000000;
    btnMenu.ChildOrder := 2;
    btnMenu.Visible := False;
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlMain.SetParentComponent(Self);
    pnlMain.Name := 'pnlMain';
    pnlMain.Left := 144;
    pnlMain.Top := 144;
    pnlMain.Width := 232;
    pnlMain.Height := 224;
    pnlMain.Caption := 'pnlMain';
    pnlMain.ChildOrder := 2;
    pnlMain.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlMain);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 16;
    WebLabel1.Width := 105;
    WebLabel1.Height := 25;
    WebLabel1.Caption := 'Anmeldung';
    WebLabel1.ChildOrder := 3;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -19;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(pnlMain);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 16;
    WebLabel2.Top := 56;
    WebLabel2.Width := 76;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Benutzername';
    WebLabel2.ChildOrder := 4;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(pnlMain);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 104;
    WebLabel3.Width := 47;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Passwort';
    WebLabel3.ChildOrder := 5;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    edtUsername.SetParentComponent(pnlMain);
    edtUsername.Name := 'edtUsername';
    edtUsername.Left := 16;
    edtUsername.Top := 72;
    edtUsername.Width := 200;
    edtUsername.Height := 22;
    edtUsername.HeightPercent := 100.000000000000000000;
    edtUsername.Text := 'edtUsername';
    edtUsername.WidthPercent := 100.000000000000000000;
    SetEvent(edtUsername, Self, 'OnKeyDown', 'edtUsernameKeyDown');
    edtPasswort.SetParentComponent(pnlMain);
    edtPasswort.Name := 'edtPasswort';
    edtPasswort.Left := 16;
    edtPasswort.Top := 120;
    edtPasswort.Width := 200;
    edtPasswort.Height := 22;
    edtPasswort.ChildOrder := 1;
    edtPasswort.HeightPercent := 100.000000000000000000;
    edtPasswort.PasswordChar := '*';
    edtPasswort.Text := 'edtUsername';
    edtPasswort.WidthPercent := 100.000000000000000000;
    SetEvent(edtPasswort, Self, 'OnKeyDown', 'edtUsernameKeyDown');
    btnLogin.SetParentComponent(pnlMain);
    btnLogin.Name := 'btnLogin';
    btnLogin.Left := 16;
    btnLogin.Top := 160;
    btnLogin.Width := 200;
    btnLogin.Height := 48;
    btnLogin.Caption := 'Anmelden';
    btnLogin.ChildOrder := 2;
    btnLogin.Color := clNone;
    btnLogin.Glyph.LoadFromFile('ULoginForm.pnlMain.btnLogin.Glyph.png');
    btnLogin.GlyphSize := 32;
    btnLogin.HeightPercent := 100.000000000000000000;
    btnLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogin, Self, 'OnClick', 'btnLoginClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnMenu.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlMain.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    edtUsername.AfterLoadDFMValues;
    edtPasswort.AfterLoadDFMValues;
    btnLogin.AfterLoadDFMValues;
  end;
end;

end.
